import { FilterSettings } from '../../types/Main'

export const defaultOptions: FilterSettings = {
  mode: 'drawer',
  isOpen: false,
  sideDrawer: 'right',
  hasInputSearch: false,
  hasSort: false,
  filterOnClick: false,
  resetMode: 'none',
  tags: [],
  properties: [],
  sort: {
    style: 'list'
  },
  priceProps: {
    mode: 'slider'
  }
}
